<template>
  <div>
    <Row v-for="(log, index) in logsData" :key="`${log.date}-${index}`" type="flex" justify="center" align="middle" class="log-row">
        <Col span="10">{{log.date}}</Col>
        <Col span="14">{{log.detail}}</Col>
    </Row>
  </div>
</template>

<script>
// import Moment from "moment"

export default {
  props: {
    logsData: {
      type: Array,
      defalult: function() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.log-row{
  padding: 12px;
}
</style>





// WEBPACK FOOTER //
// src/pages/cleaner/order-list/order-logs.vue